import React, { useCallback, useMemo } from "react";
import "./index.css";
import MySvg from "./MySvg";
import IconGrid from "../IconGrid";

const blueTealShades = ["#00008B", "#0000CD", "#1E90FF", "#4169E1", "#4682B4", "#5F9EA0", "#008B8B", "#2F4F4F", "#00CED1", "#20B2AA", "#008080"];
const purpleLavenderShades = ["#4B0082", "#800080", "#6A0DAD", "#9932CC", "#8A2BE2", "#9400D3", "#4B0082", "#800080", "#BA55D3", "#9932CC", "#4B0082"];
const redPinkShades = ["#8B0000", "#B22222", "#A52A2A", "#CD5C5C", "#DC143C", "#C71585", "#8B0000", "#FF4500", "#B22222", "#8B4513", "#B03060"];
const tealShades = ["#008080", "#006666", "#005050", "#004040", "#003333", "#002C2C", "#00897B", "#004D40", "#002A2A", "#003333", "#004040"];

const getRandomColors = (colorArray, count) => {
  const shuffled = [...colorArray].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

function Card({ project }) {
  const colorSets = useMemo(() => [blueTealShades, purpleLavenderShades, redPinkShades, tealShades], []);

  const getRandomColorSet = useCallback(() => {
    const randomSet = colorSets[Math.floor(Math.random() * colorSets.length)];
    const colors = getRandomColors(randomSet, 11);
    return colors;
  }, [colorSets]);

  const randomColors = useMemo(() => getRandomColorSet(), [getRandomColorSet]);

  return (
    <div className="container-card">
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          top: "0",
          left: "0",
          borderRadius: "30px",
          boxShadow: `
      inset 0px 40px 60px -15px rgba(21, 16, 48, 0.8),   /* Darker and more pronounced shadow from the top */
      inset 0px -40px 60px -15px rgba(21, 16, 48, 0.8),  /* Darker shadow from the bottom */
      inset 0px 50px 80px -20px rgba(21, 16, 48, 0.6),   /* Deeper inner shadow */
      inset 0px -50px 80px -20px rgba(21, 16, 48, 0.6),  /* More inner shadow from the bottom */
      0px 2px 1px rgba(21, 16, 48, 0.2),                /* Subtle outer shadow */
      0px 4px 2px rgba(21, 16, 48, 0.27),               /* Slightly larger outer shadow */
      0px 8px 4px rgba(21, 16, 48, 0.27),               /* Increased outer shadow size */
      0px 16px 8px rgba(21, 16, 48, 0.27),              /* Larger outer shadow */
      0px 32px 16px rgba(21, 16, 48, 0.27)              /* Largest outer shadow */
    `,
        }}
      ></div>
      <a href={project?.link} target="_blank" rel="noopener noreferrer">
        <img
          src={project.logo}
          alt="Project Logo"
          style={{
            height: "200px",
            width: "60%",
            position: "absolute",
            right: "2%",
            bottom: "20%",
            zIndex: 20,
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", // Adding shadow to the image
          }}
        />
      </a>
      <header
        className="text-3xl"
        style={{
          fontWeight: "500",
          height: "auto",
          width: "100%",
          position: "absolute",
          left: "5%",
          top: "4%",
          zIndex: 20,
          borderRadius: "10px",
          fontSize: "1.9rem",
        }}
      >
        {project.header}
      </header>
      <IconGrid iconUrls={project.techstack} />
      <footer
        className="text-xl"
        style={{
          height: "auto",
          width: "100%",
          position: "absolute",
          left: "5%",
          bottom: "5%",
          zIndex: 20,
          borderRadius: "10px",
        }}
      >
        {project.footer}
      </footer>
      <MySvg className="scale-svg" colorArray={randomColors} />
    </div>
  );
}

export default Card;
